import { ReactComponent as P2PIcon } from '@/assets/icons/peer-to-peer.svg';

import classes from './P2PAdminPanel.module.css';

const P2PAdminHeader: React.FC<{}> = () => {
    return (
        <div className={`${classes['p2p-main-header']} ${classes['flex']}`}>
            <P2PIcon width={24} height={24} fill="#ffffff" />
            <h2>P2P Connections</h2>
        </div>
    );
};
export default P2PAdminHeader;
